<script>
import DatePicker from "../../plugins/DatePicker/DatePicker.vue";
import Map2d from "../../plugins/map2d/Main";
import Vue from "vue";
import { apiData } from "../../api/index";
import Overlay from "ol/Overlay";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Style, Stroke, Fill } from "ol/style";
import GeoJSON from "ol/format/GeoJSON";

export default {
  name: "LiveData",
  data() {
    return {
      sRadarTime: this.$moment()
        .subtract(45, "hour")
        .format("YYYY-MM-DD HH:mm:00"), // 雷达的时间限制范围
      eRadarTime: this.$moment().format("YYYY-MM-DD HH:mm:00"), // 雷达的时间限制范围
      codesInfo: {
        A01: {
          componentName: "ImageByMap",
          group: "imageProduct",
        },
        A03: {
          componentName: "Thunder",
          group: "Thunder",
        },
        A04: {
          componentName: "ImageByMap",
          group: "ImageByMap",
        },
        A13: {
          componentName: "LiveByMap",
          group: "LiveByMap",
        },
      },
      components: [],
      componentsTabbar: [],
      currentRadarTime: this.$moment().format("YYYY-MM-DD HH:mm:00"), // 雷达的当前时间
      checkRadarELe: ["A01"],
      radarEles: [
        {
          value: "A01",
          label: "组合反射率",
        },
      ],
      // checkCloudELe: [],
      // cloudEles: [
      //   {
      //     value: "A04",
      //     label: "卫星云图",
      //   },
      // ],
      checkLightningELe: [],
      lightningEles: [
        {
          value: "A03",
          label: "闪电定位",
        },
      ],
      currentEle: "A01", // 雷达图与卫星云图互斥
      options: {
        view: {
          // center: [113.580637, 23.25178],
          center: [112.922717, 23.128762],
          zoom: 10,
          maxZoom: 20,
          minZoom: 5,
          // 设置缩放级别为整数
          constrainResolution: true,
          // 关闭无极缩放
          smoothResolutionConstraint: false,
          projection: "EPSG:4326",
        },
        map: [
          {
            name: "街道地图",
            ename: "openstreetmap",
            url: ["https://www.fspms.cn/map/light/{z}/{x}/{y}.jpg"],
            maxZoom: 18,
          },
        ],
        graticule: {
          strokeColor: "#E6A23Caa",
          strokeWidth: 1,
          targetSize: 200,
        },
      },
      stationLayer: "",
      thunderLayer: "",
      stationData: {}, // 地图站点对应的数据
      displayLayer: null,
    };
  },
  methods: {
    init() {
      // 初始化地图
      this.map2d = new Map2d(this.options);
      const company = this.$route.params.company;
      console.log("company", company);
      const { unit } = JSON.parse(localStorage.getItem(company));
      const objsList = JSON.parse(localStorage.getItem("objsList"));
      let centlat, centlon;
      if (!unit.centlat || !unit.centlon) {
        centlat = objsList[0].lat;
        centlon = objsList[0].lon;
      } else {
        centlat = unit.centlat;
        centlon = unit.centlon;
      }
      const maplevel = unit.maplevel || 9;
      this.map2d.map.getView().setCenter([centlon, centlat]);
      this.map2d.map.getView().setZoom(maplevel);
    },
    async showPlaneGeoJson() {
      const { company } = this.$route.params;
      console.log("company", company);
      const { unit } = JSON.parse(localStorage.getItem(company));
      const geojson = await apiData.getGeoJson(unit.plotjson);

      this.displayLayer = new VectorLayer({
        source: new VectorSource({
          features: new GeoJSON().readFeatures(geojson),
        }),
        style: new Style({
          stroke: new Stroke({
            color: "#2f4c7b",
            width: 3,
          }),
          fill: new Fill({
            color: "rgba(62, 109, 132, 0)",
          }),
        }),
      });
      this.displayLayer.setZIndex(9);
      this.map2d.map.addLayer(this.displayLayer);
    },
    /**
     * 加载产品
     * @param {String} ename
     */
    async loadProduct(ename) {
      const index = this.components.findIndex((item) => item.ename === ename);
      let result = true;
      if (index < 0) {
        let componentName = ename;
        if (this.codesInfo[ename]) {
          componentName = this.codesInfo[ename].componentName;
        }
        await import("../../components/service/" + componentName + ".vue")
          .then((modules) => {
            Vue.component(ename, (resolve) => resolve(modules));
            const productInfo = this.codesInfo[ename];

            this.components.push({
              ename,
              params: {
                curEle: ename,
                flag: true,
                map2d: this.map2d,
                productInfo,
              },
            });
          })
          .catch(() => {
            this.$message.error("该模块正在建设中！");

            result = false;
          });
      } else {
        this.components[index].params.flag = true;
      }
      return result;
    },
    // 通用的互斥逻辑处理方法
    handleExclusiveLoading(targetEname) {
      const exclusiveEnames = ["A01", "A04"]; // 需要互斥的组件名称

      this.components.forEach((component) => {
        if (exclusiveEnames.includes(component.ename)) {
          component.params.flag = component.ename === targetEname; // 只有目标组件设置为 true
        }
      });
    },
    callbackRadar(time) {
      this.currentRadarTime = this.$moment(time).format("YYYY-MM-DD HH:mm:00");
    },
    hanldRadarChange() {
      this.currentEle = this.checkRadarELe[0]; // 获取当前选中的值

      if (this.currentEle === "A01") {
        this.checkCloudELe = [];
        this.handleExclusiveLoading("A01"); // 加载 A01，重置 A04
        this.loadProduct("A01");
      } else {
        // 如果取消选中 A01，则隐藏 A01
        const index = this.components.findIndex((item) => item.ename === "A01");
        if (index !== -1) {
          this.components[index].params.flag = false;
        }
      }
    },
    callbackCloud(time) {
      time = this.$moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
    hanldCloudChange() {
      this.currentEle = this.checkCloudELe[0]; // 获取当前选中的值

      if (this.currentEle === "A04") {
        this.checkRadarELe = [];
        this.handleExclusiveLoading("A04"); // 加载 A01，重置 A04
        this.loadProduct("A04");
      } else {
        // 如果取消选中 A01，则隐藏 A01
        const index = this.components.findIndex((item) => item.ename === "A01");
        if (index !== -1) {
          this.components[index].params.flag = false;
        }
      }
    },
    callbackLightning(time) {
      time = this.$moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
    hanldLightningChange() {
      if (this.checkLightningELe.length > 0) {
        this.loadProduct(this.checkLightningELe[0]);
      } else {
        const index = this.components.findIndex((item) => item.ename === "A03");
        if (index !== -1) {
          this.components[index].params.flag = false;
        }
      }
    },
    addPointOverLayer() {
      const overlayerElement = this.$refs.overlayerRef;
      this.stationLayer = new Overlay({
        id: "overlayer",
        element: overlayerElement,
        positioning: "bottom-center",
        offset: [160, 100],
        stopEvent: true,
        autoPan: true,
        position: undefined,
        // offset // 正值分别向右和向下偏移
      });
      this.map2d.map.addOverlay(this.stationLayer);
      const overlayerElementThunder = this.$refs.overlayerThunderRef;
      this.thunderLayer = new Overlay({
        id: "overlayerThunder",
        element: overlayerElementThunder,
        positioning: "bottom-center",
        offset: [160, 100],
        stopEvent: true,
        autoPan: true,
        position: undefined,
        // offset // 正值分别向右和向下偏移
      });
      this.map2d.map.addOverlay(this.thunderLayer);
    },
    mapLister() {
      // 地图鼠标移动事件
      this.map2d.map.on("pointermove", (ev) => {
        const pixel = ev.pixel;
        const feature = this.map2d.map.forEachFeatureAtPixel(
          pixel,
          (feature) => {
            return feature;
          },
        );
        if (feature) {
          if (feature.get("liveData")) {
            const data = feature.get("liveData");
            console.log("data", data);
            if (data) {
              const { lon, lat } = feature.get("liveData");
              this.map2d.map.getTargetElement().style.cursor = "pointer";
              this.stationLayer.setPosition([lon, lat]);
              this.stationData = data;
            }
          }
          if (feature.get("thunderFeatureData")) {
            const data = feature.get("thunderFeatureData");
            console.log("data", data);
            if (data) {
              this.map2d.map.getTargetElement().style.cursor = "pointer";
              const { lon, lat } = feature.get("thunderFeatureData");
              this.thunderLayer.setPosition([lon, lat]);
              this.stationData = data;
            }
          }
        } else {
          this.map2d.map.getTargetElement().style.cursor = "";
          this.stationLayer.setPosition(undefined);
          this.thunderLayer.setPosition(undefined);
        }
      });
    },
    changeValue(value) {
      if (
        !value ||
        value === -999.9 ||
        value === 999.9 ||
        value === -9999 ||
        value === 9999
      ) {
        return "--";
      } else {
        return value;
      }
    },
  },
  async mounted() {
    this.init();
    this.showPlaneGeoJson();
    this.addPointOverLayer();
    this.mapLister();
    await this.loadProduct("A13");
    await this.loadProduct(this.currentEle);
  },
  components: {
    DatePicker,
  },
};
</script>
<template>
  <div class="main">
    <div id="map"></div>
    <!-- 鼠标经过显示的站点信息图层 -->
    <div ref="overlayerRef" class="overlayerRef">
      <div class="title">站点信息</div>
      <div class="content">
        <table>
          <tr>
            <td>站点名称</td>
            <td colspan="3">{{ stationData.objname }}</td>
          </tr>
          <tr>
            <td>时间</td>
            <td colspan="3">{{ stationData.ddatetime }}</td>
          </tr>
          <tr>
            <td>温度</td>
            <td colspan="3">{{ changeValue(stationData.t) }}(℃)</td>
          </tr>
          <tr>
            <td>平均风</td>
            <td colspan="3">{{ changeValue(stationData.wd2df) }}(m/s)</td>
          </tr>
          <tr>
            <td>瞬时风</td>
            <td colspan="3">{{ changeValue(stationData.wd3smaxdf) }}(m/s)</td>
          </tr>
          <tr>
            <td>相对湿度</td>
            <td colspan="3">{{ changeValue(stationData.rh) }}(%)</td>
          </tr>
          <tr>
            <td>当前小时降水</td>
            <td colspan="3">{{ changeValue(stationData.r01h) }}(mm)</td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 鼠标经过显示的站点信息图层 -->
    <div ref="overlayerThunderRef" class="overlayerRef">
      <div class="title">闪电产品详情信息</div>
      <div class="content">
        <table>
          <tr>
            <td>位置</td>
            <td colspan="3">{{ stationData.lon }}N / {{ stationData.lat }}E</td>
          </tr>
          <tr>
            <td>时间</td>
            <td colspan="3">
              {{ $moment(stationData.crttime).format("YYYY-MM-DD HH:mm") }}
            </td>
          </tr>
          <tr>
            <td>电流</td>
            <td colspan="3">{{ stationData.intensity }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="panel">
      <img
        class="title-img"
        src="@/assets/images/service/观测资料-小标题@2x.png"
        alt=""
      />
      <div class="content">
        <div v-for="item in components" :key="item.ename">
          <component
            :is="item.ename"
            v-if="item.ename === 'A13'"
            :params="item.params"
            ref="cpnRef"
          ></component>
        </div>
        <div class="content-item">
          <div class="content-item-title">雷达产品</div>
          <date-picker
            @callback="callbackRadar"
            :interval="6"
            :delayTime="12"
            :DatetimeRange="[sRadarTime, eRadarTime]"
          ></date-picker>
          <el-checkbox-group v-model="checkRadarELe" @change="hanldRadarChange">
            <el-checkbox
              v-for="item in radarEles"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <!-- <div class="content-item">
          <div class="content-item-title">卫星产品</div>
          <date-picker @callback="callbackCloud"></date-picker>
          <el-checkbox-group v-model="checkCloudELe" @change="hanldCloudChange">
            <el-checkbox
              v-for="item in cloudEles"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
        </div> -->
        <div class="content-item">
          <div class="content-item-title">闪电</div>
          <date-picker @callback="callbackLightning"></date-picker>
          <el-checkbox-group
            v-model="checkLightningELe"
            @change="hanldLightningChange"
          >
            <el-checkbox
              v-for="item in lightningEles"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div v-for="item in components" :key="item.ename">
      <component
        :is="item.ename"
        v-if="item.ename !== 'A13'"
        :params="item.params"
        ref="cpnRef"
        :time="currentRadarTime"
      ></component>
    </div>
  </div>
</template>

<style lang="less" scoped>
.main {
  flex: 1;
  position: relative;
  #map {
    width: 100%;
    height: 100%;
  }
  .panel {
    position: absolute;
    top: 1.8519vh;
    left: 1.04vw;
    width: 19.64vw;
    height: 88.7037vh;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0px 11px 18px 0px rgba(139, 157, 189, 0.35);
    border-radius: 6px;
    .title-img {
      width: 100%;
      height: 4.1333vh;
      object-fit: contain;
    }
    .content {
      padding: 1.1111vh 0.83vw;
      display: flex;
      flex-direction: column;
      gap: 1.1111vh;
      .content-item {
        display: flex;
        flex-direction: column;
        gap: 1.1111vh;
        .content-item-title {
          padding: 0 0.63vw;
          height: 3.4259vh;
          display: flex;
          align-items: center;
          background: #def0ff;
          border-radius: 0.21vw;
          font-weight: 600;
          font-size: 0.83vw;
          color: #333333;
        }
        /deep/.DatePicker {
          color: #0a0a0a;
          .picker-box-inner {
            background: rgba(247, 250, 255, 0.49);
            box-shadow: 0px 4px 8px 0px rgba(192, 220, 244, 0.43);
            border-radius: 4px;
            border: 1px solid #e3ebed;
            .date-picker {
              width: 6.03vw;
            }
            .select-box {
              width: 1.5vw;
            }
            .el-input__inner {
              color: #0a0a0a;
            }
            .el-input__prefix {
              color: #9b9c9f;
            }
            .icon-caret-top {
              border-bottom: 0.5em solid #9b9c9f;
            }
            .icon-caret-bottom {
              border-top: 0.5em solid #9b9c9f;
            }
          }
        }
        /deep/.el-checkbox-group {
          display: flex;
          flex-wrap: wrap;
          gap: 1.8519vh 0;
          .el-checkbox {
            margin-right: 0;
            width: 50%;
          }
          .el-checkbox__inner {
            width: 0.83vw;
            height: 0.83vw;
            border-radius: 3px;
            border: 1px solid #c6cdcf;
          }
          .el-checkbox__label {
            font-size: 0.73vw;
            color: #333333;
          }
        }
      }
    }
  }
  .overlayerRef {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    box-shadow: 0vw 0vw 0.47vw 0vw rgba(184, 184, 184, 0.5);
    border-radius: 0.26vw;
    font-size: 0.73vw;
    color: #8d8d8d;
    line-height: 1.5vw;
    .title {
      color: #fff;
      background-color: #3379f5;
      padding: 0.52vw;
      font-size: 0.83vw;
    }
    .content {
      table {
        border-collapse: collapse;
        tr {
          border-bottom: 1px solid #ccc;
        }
        tr:nth-child(even) {
          background-color: #eff1f3;
        }
        td {
          text-align: center;
          width: 8vw;
          border-right: 1px solid #ccc;
        }
      }
    }
  }
}
</style>
